(() => {
  const closeDelay = 180;

  const initializeMegaMenus = (root = document) => {
    root.querySelectorAll('products-mega-menu').forEach((menu) => {
      if (menu.dataset.softHoverExitReady === 'true') return;

      const details = menu.querySelector('details');
      if (!details) return;

      let closeTimer;

      const cancelClose = () => {
        window.clearTimeout(closeTimer);
      };

      const closeMenu = () => {
        window.clearTimeout(closeTimer);
        details.removeAttribute('open');
      };

      const scheduleClose = () => {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) {
            closeMenu();
          }
        }, closeDelay);
      };

      menu.addEventListener('mouseenter', cancelClose);
      menu.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('focusin', cancelClose);
      menu.addEventListener('focusout', scheduleClose);
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu();
      });

      menu.dataset.softHoverExitReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeMegaMenus());
  } else {
    initializeMegaMenus();
  }

  document.addEventListener('shopify:section:load', (event) => initializeMegaMenus(event.target));
})();
